import React, { useEffect, useState } from "react";
import "../css/donations.scss";
import { get_dontion_list } from "../apis/GetDontionList.js";
import { LIST_URL } from "../constans/ApiEndpointConstants.js";
import { useNavigate } from "react-router-dom";
import Loading1 from "./common/Loading1.js";
import { generateDonationUrl } from "../utils/urlUtils";

const Donations = () => {
  const [donationsData, setDonationsData] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  // 获取捐款列表计算动态数据
  useEffect(() => {
    const fetchOrderDonations = async () => {
      setLoading(true);
      try {
        const response = await get_dontion_list("1", "20000", "US");
        const orders = response?.data ?? response ?? [];
        const projectList = orders.projects;

        // Ensure we have an array and shuffle it so the display order is random
        const rawList = Array.isArray(projectList)
          ? projectList.slice()
          : Array.isArray(orders)
          ? orders.slice()
          : [];

        const shuffleArray = (arr) => {
          for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const tmp = arr[i];
            arr[i] = arr[j];
            arr[j] = tmp;
          }
          return arr;
        };

        setDonationsData(shuffleArray(rawList));
      } catch (error) {
        console.error("Failed to fetch order list:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDonations();
  }, []);

  const parseAmount = (val) => {
    if (val == null) return 0;
    if (typeof val === "number") return val;
    const s = String(val).replace(/[^0-9.-]+/g, "");
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  };

  const computeProgress = (item) => {
    if (!item) return 0;
    if (typeof item.progress === "number")
      return Math.max(0, Math.min(1, item.progress));
    const raised = parseAmount(
      item.raised ?? item.raised_amount ?? item.raisedAmount
    );
    const goal = parseAmount(item.goal ?? item.goal_amount ?? item.goalAmount);
    if (goal > 0) return Math.max(0, Math.min(1, raised / goal));
    return 0;
  };

  const resolveImageUrl = (raw) => {
    if (!raw) return "";
    if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) return raw;
    const base = LIST_URL.endsWith("/") ? LIST_URL.slice(0, -1) : LIST_URL;
    return raw.startsWith("/") ? base + raw : base + "/" + raw;
  };

  // pagination handlers: move the visible list window by 5 items
  useEffect(() => {
    // reset to first page when data changes
    setStartIndex(0);
    setShowMore(false);
  }, [donationsData]);

  useEffect(() => {
    const onResize = () => {
      try {
        setIsMobile(window.innerWidth <= 767);
      } catch (e) {
        setIsMobile(false);
      }
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(0, prev - 5));
  };

  const handleNext = () => {
    const totalItems = donationsData?.length || 0;
    const maxStart = Math.max(0, totalItems - 5);
    setStartIndex((prev) => Math.min(maxStart, prev + 5));
  };

  if (loading) {
    return (
      <div className="donations">
        <Loading1 />
      </div>
    );
  }

  return (
    <section className="donations">
      <div className="donations__inner">
        <div className="donations__header">
          <h2>Discover fundraisers inspired by what you care about</h2>
          <div className="donations__controls">
            <div className="view-all-wrap">
              <button
                className="view-all"
                onClick={() => {
                  navigate("/donations");
                }}
                aria-label="View all fundraisers"
              >
                View all
              </button>
            </div>
            {!isMobile && (
              <div className="arrows">
                <button
                  className="arrow"
                  onClick={handlePrev}
                  disabled={startIndex <= 0}
                  aria-label="Previous"
                >
                  ←
                </button>
                <button
                  className="arrow"
                  onClick={handleNext}
                  disabled={
                    startIndex >= Math.max(0, (donationsData?.length || 0) - 5)
                  }
                  aria-label="Next"
                >
                  →
                </button>
              </div>
            )}
            {/* View all button: navigates to the full donations list page */}
          </div>
        </div>

        <div className="donations__grid">
          <article
            className="donations__featured"
            onClick={() => {
              const url = generateDonationUrl(donationsData?.[startIndex]);
              if (url) navigate(url);
            }}
          >
            <div className="card media-card">
              <div className="card__img-wrap">
                <img
                  src={resolveImageUrl(
                    donationsData?.[startIndex]?.image?.[0]?.url
                  )}
                  alt=""
                />
              </div>
              <h3 className="card__title">
                {donationsData && donationsData[startIndex] ? (
                  donationsData[startIndex].title
                ) : (
                  <div className="donations">
                    <Loading1 />
                  </div>
                )}
              </h3>
              <div className="progress-wrap">
                <div className="progress">
                  <div
                    className="progress__value"
                    style={{
                      width: `${
                        computeProgress(donationsData?.[startIndex]) * 100
                      }%`,
                    }}
                  />
                </div>
                <div className="raised">
                  {donationsData?.[startIndex]?.currency_name || ""}
                  {donationsData && donationsData[startIndex]
                    ? donationsData[startIndex].raised || ""
                    : ""}
                  {donationsData && donationsData[startIndex] ? " raised" : ""}
                </div>
              </div>
            </div>
          </article>

          <div className="donations__list">
            {(Array.isArray(donationsData)
              ? isMobile
                ? showMore
                  ? donationsData.slice(startIndex + 1)
                  : donationsData.slice(startIndex + 1, startIndex + 3)
                : donationsData.slice(startIndex + 1, startIndex + 5)
              : []
            ).map((d, idx) => (
              <article
                className="donations__card"
                key={idx}
                onClick={() => {
                  const url = generateDonationUrl(d);
                  if (url) navigate(url);
                }}
              >
                <div className="card">
                  <div className="card__img-wrap small">
                    <img
                      src={resolveImageUrl(d.image?.[0]?.url || d.img || "")}
                      alt=""
                    />
                    <span className="badge">{d.postType}</span>
                  </div>
                  <div className="card__txt-wrap">
                    <span className="card_insightSmall__m8Rnl">
                      {d.postType}
                    </span>

                    <h4 className="card__title">{d.title}</h4>
                    <div className="progress-wrap">
                      <div className="progress">
                        <div
                          className="progress__value"
                          style={{ width: `${computeProgress(d) * 100}%` }}
                        />
                      </div>
                      <div className="raised">
                        {d?.currency_name || ""}
                        {d?.raised || ""} raised
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            ))}
            {isMobile &&
              !showMore &&
              Array.isArray(donationsData) &&
              donationsData.length > 3 && (
                <div style={{ marginTop: 16 }}>
                  <button
                    className="show-more"
                    onClick={() => setShowMore(true)}
                    aria-label="Show more"
                  >
                    Show more
                  </button>
                </div>
              )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Donations;
